import { toRaw } from "vue";

function unwrap(value) {
  const raw = toRaw(value);

  if (Array.isArray(raw)) {
    return raw.map(unwrap);
  }

  if (raw && typeof raw === "object") {
    if (Object.prototype.toString.call(raw) !== "[object Object]") {
      throw new TypeError("Finder data must contain only plain records, arrays, and primitive values");
    }

    return Object.fromEntries(Object.entries(raw).map(([key, child]) => [key, unwrap(child)]));
  }

  return raw;
}

/** Clones plain search data, unwrapping nested Vue proxies. Throws for unsupported values. */
export function cloneFinderData(value) {
  return structuredClone(unwrap(value));
}

/** Compares plain search data without depending on object key order; array order remains significant. */
export function equalFinderData(left, right) {
  if (left === right || (Number.isNaN(left) && Number.isNaN(right))) {
    return true;
  }

  if (!left || !right || typeof left !== "object" || typeof right !== "object") {
    return false;
  }

  if (Array.isArray(left) !== Array.isArray(right)) {
    return false;
  }

  if (Array.isArray(left) && left.length !== right.length) {
    return false;
  }

  if (!Array.isArray(left) && Object.prototype.toString.call(left) !== "[object Object]") {
    return false;
  }

  if (!Array.isArray(right) && Object.prototype.toString.call(right) !== "[object Object]") {
    return false;
  }

  const leftKeys = Object.keys(left);
  const rightKeys = Object.keys(right);

  return (
    leftKeys.length === rightKeys.length &&
    leftKeys.every((key) => Object.hasOwn(right, key) && equalFinderData(left[key], right[key]))
  );
}
